<script>
export default {
  data() {
    return {
      languageCode: this.page.language + '-' + this.page.countryCode,
    };
  },

  created() {
    this.addDateValues();
  },

  mounted() {
    this.addLeadData();
  },

  methods: {
    addDateValues() {
      const date = new Date();

      const $YEAR = date.getFullYear();
      this.$store.commit('page/setVariable', { key: '$YEAR', value: $YEAR });

      const $NEXT_YEAR = $YEAR + 1;
      this.$store.commit('page/setVariable', { key: '$NEXT_YEAR', value: $NEXT_YEAR });

      const $MONTH = new Intl.DateTimeFormat(this.languageCode, { month: 'long' }).format(date);
      this.$store.commit('page/setVariable', { key: '$MONTH', value: $MONTH });

      const quarter = new Date(`${Math.floor((date.getMonth() + 3) / 3) * 3}/01/2022`);
      const $QUARTER = new Intl.DateTimeFormat(this.languageCode, { month: 'long' }).format(quarter);
      this.$store.commit('page/setVariable', { key: '$QUARTER', value: $QUARTER });

      const $LAST_DAY_OF_MONTH = new Intl.DateTimeFormat(this.languageCode, { day: 'numeric' }).format(new Date($YEAR, date.getMonth() + 1, 0));
      this.$store.commit('page/setVariable', { key: '$LAST_DAY_OF_MONTH', value: $LAST_DAY_OF_MONTH });
    },

    addLeadData() {
        const leadData = this.$store.state.page.leadData;

        if(!leadData) return;

        for(const [dataKey, value] of Object.entries(leadData)) {
            let key = dataKey.replace('extradata-', '');
            this.$store.commit('page/setVariable', { key, value });
        }
    },
  },
};
</script>
